// src/env/schema.ts
import { z } from "zod";
var sharedEnvSchema = z.object({
  VITE_API_BASE_URL: z.string().url().optional(),
  VITE_SESSION_INACTIVITY_TIMEOUT: z.coerce.number().positive().optional(),
  VITE_SESSION_WARNING_TIME: z.coerce.number().positive().optional(),
  VITE_SESSION_PRESET: z.enum(["standard", "testing", "development", "extended", "strict"]).optional(),
  VITE_GA_MEASUREMENT_ID: z.string().optional(),
  VITE_I18N_COOKIE_DOMAIN: z.string().optional()
});
var portalEnvSchema = sharedEnvSchema.extend({
  VITE_ONBOARDING_APP_BASE_URL: z.string().url().optional()
});
var onboardingEnvSchema = sharedEnvSchema.extend({
  VITE_PORTAL_APP_BASE_URL: z.string().url().optional()
});

// src/env/portal.ts
var _parsed = portalEnvSchema.safeParse({
  VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  VITE_ONBOARDING_APP_BASE_URL: import.meta.env.VITE_ONBOARDING_APP_BASE_URL,
  VITE_SESSION_INACTIVITY_TIMEOUT: import.meta.env.VITE_SESSION_INACTIVITY_TIMEOUT,
  VITE_SESSION_WARNING_TIME: import.meta.env.VITE_SESSION_WARNING_TIME,
  VITE_SESSION_PRESET: import.meta.env.VITE_SESSION_PRESET,
  VITE_GA_MEASUREMENT_ID: import.meta.env.VITE_GA_MEASUREMENT_ID,
  VITE_I18N_COOKIE_DOMAIN: import.meta.env.VITE_I18N_COOKIE_DOMAIN
});
if (!_parsed.success) {
  console.error(
    "[Config] Portal environment validation failed:",
    _parsed.error.format()
  );
}
var _a, _b, _c, _d, _e, _f, _g;
var env = {
  ONBOARDING_APP_BASE_URL: ((_a = window.__ENV__) == null ? void 0 : _a.VITE_ONBOARDING_APP_BASE_URL) || import.meta.env.VITE_ONBOARDING_APP_BASE_URL || "http://localhost:3003",
  API_BASE_URL: ((_b = window.__ENV__) == null ? void 0 : _b.VITE_API_BASE_URL) || import.meta.env.VITE_API_BASE_URL || "http://localhost:3030/api/v1",
  SESSION_INACTIVITY_TIMEOUT: ((_c = window.__ENV__) == null ? void 0 : _c.VITE_SESSION_INACTIVITY_TIMEOUT) || Number(import.meta.env.VITE_SESSION_INACTIVITY_TIMEOUT) || 3e5,
  SESSION_WARNING_TIME: ((_d = window.__ENV__) == null ? void 0 : _d.VITE_SESSION_WARNING_TIME) || Number(import.meta.env.VITE_SESSION_WARNING_TIME) || 3e4,
  SESSION_PRESET: ((_e = window.__ENV__) == null ? void 0 : _e.VITE_SESSION_PRESET) || import.meta.env.VITE_SESSION_PRESET || "extended",
  GA_MEASUREMENT_ID: ((_f = window.__ENV__) == null ? void 0 : _f.VITE_GA_MEASUREMENT_ID) || import.meta.env.VITE_GA_MEASUREMENT_ID || "",
  I18N_COOKIE_DOMAIN: ((_g = window.__ENV__) == null ? void 0 : _g.VITE_I18N_COOKIE_DOMAIN) ?? import.meta.env.VITE_I18N_COOKIE_DOMAIN ?? "",
  IS_DEV: import.meta.env.DEV
};
var debugEnvConfig = () => {
  if (import.meta.env.DEV) {
    console.group("Portal Environment Configuration");
    console.log("Runtime Config (window.__ENV__):", window.__ENV__);
    console.log("Build-time Config (import.meta.env):", {
      VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
      VITE_SESSION_INACTIVITY_TIMEOUT: import.meta.env.VITE_SESSION_INACTIVITY_TIMEOUT,
      VITE_SESSION_WARNING_TIME: import.meta.env.VITE_SESSION_WARNING_TIME,
      VITE_SESSION_PRESET: import.meta.env.VITE_SESSION_PRESET
    });
    console.log("Final Config (env):", env);
    console.groupEnd();
  }
};
export {
  debugEnvConfig,
  env
};
//# sourceMappingURL=portal.js.map